export default {"src":"/_next/static/media/card-1.86d560df.svg","height":194,"width":306,"blurWidth":0,"blurHeight":0};